import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';

import { AdminRowOperation } from '../ag-grid-cell-renderers/admin-row-operations.component';

@Component({
  selector: 'custom-admin-row-operations-filter',
  template: `
    <div class="padding-10" fxLayout="column" fxFlex>
      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="viewSelected" (change)="selectionChanged()">
        {{ 'CUSTOM_CONTENT.view' | translate }}
      </mat-checkbox>

      <mat-checkbox
        *ngIf="userHasEditPermissions"
        color="primary"
        class="padding-5"
        [(ngModel)]="editSelected"
        (change)="selectionChanged()"
      >
        {{ 'CUSTOM_CONTENT.edit' | translate }}
      </mat-checkbox>

      <mat-checkbox
        *ngIf="userHasEditPermissions"
        color="primary"
        class="padding-5"
        [(ngModel)]="activateSelected"
        (change)="selectionChanged()"
      >
        {{ 'CUSTOM_CONTENT.activate' | translate }}
      </mat-checkbox>

      <mat-checkbox
        *ngIf="userHasEditPermissions"
        color="primary"
        class="padding-5"
        [(ngModel)]="deactivateSelected"
        (change)="selectionChanged()"
      >
        {{ 'CUSTOM_CONTENT.deactivate' | translate }}
      </mat-checkbox>

      <mat-checkbox
        *ngIf="userHasEditPermissions"
        color="primary"
        class="padding-5"
        [(ngModel)]="deleteSelected"
        (change)="selectionChanged()"
      >
        {{ 'CUSTOM_CONTENT.delete' | translate }}
      </mat-checkbox>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep label.mat-checkbox-layout {
        width: 100%;
      }
      :host ::ng-deep label .mat-checkbox-inner-container {
        margin-left: 0px;
      }
    `,
  ],
})
export class CustomAdminRowOperationsFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  private colId: string;
  public userHasEditPermissions: boolean;
  public viewSelected: boolean = true;
  public editSelected: boolean = true;
  public deactivateSelected: boolean = true;
  public activateSelected: boolean = true;
  public deleteSelected: boolean = true;

  constructor(private cService: CommonService) {}

  agInit(params: IFilterParams) {
    this.params = params;
    this.colId = params.colDef.colId;
    this.userHasEditPermissions =
      this.cService.userProfile.userPermissions.permMISNotifications === this.cService.permLevels.viewEdit;
  }

  isFilterActive(): boolean {
    return (
      !this.viewSelected ||
      !this.editSelected ||
      !this.deactivateSelected ||
      !this.activateSelected ||
      !this.deleteSelected
    );
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const cellValue = params.data[this.colId];
    let includeView: boolean,
      includeEdit: boolean,
      includeDeactivate: boolean,
      includeActivate: boolean,
      includeDelete: boolean,
      includeEmpty: boolean;

    includeView = this.checkCondition(this.viewSelected, cellValue, AdminRowOperation.view);
    includeEdit = this.checkCondition(this.editSelected, cellValue, AdminRowOperation.edit);
    includeDeactivate = this.checkCondition(this.deactivateSelected, cellValue, AdminRowOperation.deactivate);
    includeActivate = this.checkCondition(this.activateSelected, cellValue, AdminRowOperation.activate);
    includeDelete = this.checkCondition(this.deleteSelected, cellValue, AdminRowOperation.delete);

    // Catch all - nothing selected
    if (
      !this.viewSelected &&
      !this.editSelected &&
      !this.deactivateSelected &&
      !this.activateSelected &&
      !this.deleteSelected
    ) {
      includeEmpty = cellValue == null;
    }

    return includeView || includeEdit || includeDeactivate || includeActivate || includeDelete || includeEmpty;
  }

  checkCondition(condition: boolean, cellValue: string, conditionValue: string): boolean {
    if (condition) {
      return cellValue.includes(conditionValue);
    }

    return false;
  }

  getModel(): any {
    return;
  }

  setModel(model: any) {}

  // ----------------------

  selectionChanged() {
    this.params.filterChangedCallback();
  }
}
